import React, { useEffect, useState } from 'react';
import { Users, Phone } from 'lucide-react';
import PageHeader from './ui/PageHeader';
import EmptyState from './ui/EmptyState';
import StatusBadge from './ui/StatusBadge';
import apiService from '../services/apiService';

const STATUS_LABELS = {
  new: 'Yeni',
  contacted: 'İletişimde',
  converted: 'Randevuya dönüştü',
  lost: 'Kayıp',
};

export default function SocialLeads() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiService
      .fetchSocialLeads()
      .then(setLeads)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-6 lg:p-8">
      <PageHeader
        title="Sosyal Leads"
        subtitle="Kampanya DM'lerinden gelen potansiyel hastalar"
        icon={Users}
      />

      {loading ? (
        <p className="text-slate-400">Yükleniyor…</p>
      ) : leads.length === 0 ? (
        <EmptyState title="Lead yok" description="Sosyal asistan lead oluşturduğunda burada listelenir." />
      ) : (
        <div className="card overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-slate-500 border-b border-white/10">
                <th className="px-4 py-3">Ad</th>
                <th className="px-4 py-3">Telefon</th>
                <th className="px-4 py-3">İlgi</th>
                <th className="px-4 py-3">Durum</th>
                <th className="px-4 py-3">Randevu</th>
              </tr>
            </thead>
            <tbody>
              {leads.map((lead) => (
                <tr key={lead.id} className="border-b border-white/5 hover:bg-white/[0.02]">
                  <td className="px-4 py-3 text-white">{lead.name || '—'}</td>
                  <td className="px-4 py-3 text-slate-300 flex items-center gap-1">
                    <Phone className="h-3 w-3" /> {lead.phone || '—'}
                  </td>
                  <td className="px-4 py-3 text-slate-300">{lead.interest || '—'}</td>
                  <td className="px-4 py-3">
                    <StatusBadge label={STATUS_LABELS[lead.status] || lead.status} tone="info" />
                  </td>
                  <td className="px-4 py-3 text-slate-400">
                    {lead.convertedAppointmentId ? `#${lead.convertedAppointmentId}` : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
